import type { FaqItem } from '../types/content';

export const employerFaqs: FaqItem[] = [
  {
    question: 'When should we engage an executive search partner?',
    answer:
      'Executive search is most valuable for senior, strategically important, or confidential roles — particularly where the right candidates are unlikely to be actively applying, or where the organization needs access to leaders beyond its existing networks.',
  },
  {
    question: 'How do we begin a search?',
    answer:
      'Submit a hiring inquiry or email one of our consultants. We will arrange an initial conversation to understand the role, your organization, and your timeline before agreeing on a way forward.',
  },
  {
    question: 'Can a search be conducted confidentially?',
    answer:
      'Yes. For confidential assignments we agree a confidentiality protocol at the outset, use anonymised briefings in early conversations, and disclose information in stages as candidate interest is confirmed.',
  },
  {
    question: 'What information is helpful at the start?',
    answer:
      'A summary of the role and reporting line, the organization’s current priorities, the experience you believe is essential, your preferred timeline, and any confidentiality considerations. A formal job description is useful but not required.',
  },
  {
    question: 'How long does an executive search typically take?',
    answer:
      'Timelines vary with seniority, market, and complexity. We will discuss a realistic timeline for your specific search during the initial briefing rather than quoting a generic figure.',
  },
  {
    question: 'Do you only work on C-suite roles?',
    answer:
      'No. Alongside C-suite and board appointments, we support senior functional and divisional leadership roles, talent mapping, leadership advisory, and succession planning.',
  },
];
